export const EMPTY = 'EMPTY'

// general password requirements
const MIN_LENGTH = 8
export const PASSWORD_LENGTH = 'PASSWORD_LENGTH'
export const PASSWORD_LETTER = 'PASSWORD_LETTER'
export const PASSWORD_NUMBER = 'PASSWORD_NUMBER'
export const PASSWORD_SPECIAL_CHARACTER = 'PASSWORD_SPECIAL_CHARACTER'
export const PASSWORD_MATCH = 'PASSWORD_MATCH'

// Forgot password window/page
export const EMAIL = 'EMAIL'
export const EMAIL_EMPTY = 'EMAIL_EMPTY'

// Header.Sign-in
export const LOGIN_EMPTY = 'LOGIN_EMPTY'
export const PASSWORD_EMPTY = 'PASSWORD_EMPTY'

// CreateAccount page
export const CREATE_ACCOUNT_EMAIL_EMPTY = 'CREATE_ACCOUNT_EMAIL_EMPTY '
export const CREATE_ACCOUNT_EMAIL_INVALID = 'CREATE_ACCOUNT_EMAIL_INVALID '
export const CREATE_ACCOUNT_EMAIL_MISMATCH = 'CREATE_ACCOUNT_EMAIL_MISMATCH '
export const CREATE_ACCOUNT_PASSWORD_EMPTY = 'CREATE_ACCOUNT_PASSWORD_EMPTY '
export const CREATE_ACCOUNT_PASSWORD_INVALID = 'CREATE_ACCOUNT_PASSWORD_INVALID '
export const CREATE_ACCOUNT_POSTAL_CODE_INVALID = 'CREATE_ACCOUNT_POSTAL_CODE_INVALID '
export const CREATE_ACCOUNT_TERMS_AGREEMENT_DENIED = 'CREATE_ACCOUNT_TERMS_AGREEMENT_DENIED '

export const ZIP_CODE = 'ZIP_CODE'

// Personal Information
export const PERSONAL_INFORMATION_FIRST_NAME = 'PERSONAL_INFORMATION_FIRST_NAME'
export const PERSONAL_INFORMATION_LAST_NAME = 'PERSONAL_INFORMATION_LAST_NAME'
export const PERSONAL_INFORMATION_ADDRESS1 = 'PERSONAL_INFORMATION_ADDRESS1'
export const PERSONAL_INFORMATION_ADDRESS2 = 'PERSONAL_INFORMATION_ADDRESS2'
export const PERSONAL_INFORMATION_CITY = 'PERSONAL_INFORMATION_CITY'
export const PERSONAL_INFORMATION_PRIMARY_PHONE_NUMBER = 'PERSONAL_INFORMATION_PRIMARY_PHONE_NUMBER'
export const PERSONAL_INFORMATION_ALTERNATIVE_PHONE_NUMBER = 'PERSONAL_INFORMATION_ALTERNATIVE_PHONE_NUMBER'
export const PERSONAL_INFORMATION_ADDRESS_FIELDS = 'PERSONAL_INFORMATION_ADDRESS_FIELDS'
export const PERSONAL_INFORMATION_SUCCESS_STATE = 'PERSONAL_INFORMATION_SUCCESS_STATE'
export const PERSONAL_INFORMATION_USPS_VALIDATE = 'PERSONAL_INFORMATION_USPS_VALIDATE'

// Password And Security
export const PASSWORD_AND_SECURITY_EMAIL_ADDRESSES = 'PASSWORD_AND_SECURITY_EMAIL_ADDRESSES'
export const PASSWORD_AND_SECURITY_EMAIL_UPDATED = 'PASSWORD_AND_SECURITY_EMAIL_UPDATED'
export const PASSWORD_AND_SECURITY_EMPTY_PASSWORD = 'PASSWORD_AND_SECURITY_EMPTY_PASSWORD'
export const PASSWORD_AND_SECURITY_PASSWORD = 'PASSWORD_AND_SECURITY_PASSWORD'
export const PASSWORD_AND_SECURITY_PASSWORD_MATCH = 'PASSWORD_AND_SECURITY_PASSWORD_MATCH'
export const PASSWORD_AND_SECURITY_PASSWORD_UPDATED = 'PASSWORD_AND_SECURITY_PASSWORD_UPDATED'

// Communication Preference
export const COMMUNICATION_PREFERENCE_PHONE_NUMBER = 'COMMUNICATION_PREFERENCE_PHONE_NUMBER'

// Preferred Installers
export const PREFERRED_INSTALLERS_NICKNAME = 'PREFERRED_INSTALLERS_NICKNAME'

// Tire size confirmation screen
export const CONFIRM_TIRE_SIZE_PARAMETERS_EMPTY = 'CONFIRM_TIRE_SIZE_PARAMETERS_EMPTY'

/**
 * Put your rules here
 */
export const RULES = {
  [EMPTY]: /\S+/,
  [EMAIL]: /^[a-zA-Z0-9_\-+]+(\.[a-zA-Z0-9_\-+]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})$/,
  [ZIP_CODE]: /^(?:\d{5}|\d{5}-\d{4})?$/,
  [PASSWORD_LENGTH]: (str = '') => str.length >= MIN_LENGTH,
  [PASSWORD_LETTER]: (str = '') => /(?=.*[a-z])(?=.*[A-Z])/.test(str),
  [PASSWORD_NUMBER]: (str = '') => /\d/.test(str),
  [PASSWORD_SPECIAL_CHARACTER]: (str = '') => /(?=.*[*!@#$&?])/.test(str),
  [PASSWORD_MATCH]: (str1 = '', str2 = '') => str1 !== '' && str1 === str2,
  [PERSONAL_INFORMATION_FIRST_NAME]: /^[a-zA-Z\s-]{0,20}$/,
  [PERSONAL_INFORMATION_LAST_NAME]: /^[a-zA-Z\s-]{0,20}$/,
  [PERSONAL_INFORMATION_ADDRESS1]: /^[0-9a-zA-Z\s.,#;:'\-&/()]{0,40}$/,
  [PERSONAL_INFORMATION_ADDRESS2]: /^[0-9a-zA-Z\s.,#;:'\-&/()]{0,40}$/,
  [PERSONAL_INFORMATION_CITY]: /^[a-zA-Z\s]{0,25}$/,
  [PERSONAL_INFORMATION_PRIMARY_PHONE_NUMBER]: /(^$|^[0-9]{10}$)/,
  [PERSONAL_INFORMATION_ALTERNATIVE_PHONE_NUMBER]: /(^$|^[0-9]{10}$)/,
  [PREFERRED_INSTALLERS_NICKNAME]: /^[a-zA-Z0-9!@#$&()-`.+,/\\"]*$/,
  [PASSWORD_AND_SECURITY_PASSWORD]: /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,15}$/
}

/**
 * Put rules' messages here
 */
export const MESSAGES = {
  [EMAIL]: 'Please enter a valid email address.',
  [EMAIL_EMPTY]: 'Please enter your email address.',
  [LOGIN_EMPTY]: 'Email should not be empty.',
  [PASSWORD_EMPTY]: 'Please enter your password.',
  [PASSWORD_LENGTH]: `Be at least ${MIN_LENGTH} characters`,
  [PASSWORD_LETTER]: 'Be a combination of upper case and lower case characters',
  [PASSWORD_NUMBER]: 'Be alphanumeric',
  [PASSWORD_SPECIAL_CHARACTER]: 'Include at least one of the following special characters   *!@#$&?',
  [PASSWORD_MATCH]: 'Match confirmation',
  [CREATE_ACCOUNT_EMAIL_EMPTY]: 'Please enter your email address.',
  [CREATE_ACCOUNT_EMAIL_INVALID]: 'Please enter your email address.',
  [CREATE_ACCOUNT_EMAIL_MISMATCH]: 'Your email addresses do not match.',
  [CREATE_ACCOUNT_PASSWORD_EMPTY]: 'Please confirm your password.',
  [CREATE_ACCOUNT_PASSWORD_INVALID]: 'Please enter a valid password',
  [CREATE_ACCOUNT_POSTAL_CODE_INVALID]: 'Please enter a valid ZIP code.',
  [CREATE_ACCOUNT_TERMS_AGREEMENT_DENIED]: 'Please accept the Tire America Terms.',
  [ZIP_CODE]: 'Please enter a valid Zip Code. Your zip code should be 5 to 10 numeric characters.',
  [PERSONAL_INFORMATION_FIRST_NAME]: 'Your First Name may consist of letters only, up to 20. Please try again.',
  [PERSONAL_INFORMATION_LAST_NAME]: 'Your Last Name may consist of letters only, up to 20. Please try again.',
  // eslint-disable-next-line
  [PERSONAL_INFORMATION_ADDRESS1]: `Please enter a valid Address.  Your address may consist of letters, numbers and the following characters: '.', ',', '#',';', ':', ''', '-', '&', '/', '(',')', up to 40 characters.`,
  // eslint-disable-next-line
  [PERSONAL_INFORMATION_ADDRESS2]: `Please enter a valid Address.  Your address may consist of letters, numbers and the following characters: '.', ',', '#',';', ':', ''', '-', '&', '/', '(',')', up to 40 characters.`,
  [PERSONAL_INFORMATION_CITY]: 'Please enter a valid City. Your city may consist of letters only, up to 25.',
  [PERSONAL_INFORMATION_PRIMARY_PHONE_NUMBER]: 'Please enter a valid Mobile Phone Number. It should consist of 10 numeric characters.',
  [PERSONAL_INFORMATION_ALTERNATIVE_PHONE_NUMBER]: 'Please enter a valid Alternative Phone Number. It should consist of 10 numeric characters.',
  [PERSONAL_INFORMATION_ADDRESS_FIELDS]: 'Please enter your address information',
  [PERSONAL_INFORMATION_SUCCESS_STATE]: 'Your personal information has been updated.',
  [PERSONAL_INFORMATION_USPS_VALIDATE]: 'USPS could not validate this address.',
  // eslint-disable-next-line
  [PREFERRED_INSTALLERS_NICKNAME]: `Please enter a valid nickname. Installer nickname may consist of letters, numbers and the following characters: '!', '@', '#', '$', &', (, ')', '-', ' ' ', '.' , '/', '+', ',', ' " ' up to 10 characters`,
  [COMMUNICATION_PREFERENCE_PHONE_NUMBER]: 'Please enter your phone number',
  [PASSWORD_AND_SECURITY_EMAIL_ADDRESSES]: 'Your email addresses do not match. Please try again.',
  [PASSWORD_AND_SECURITY_EMAIL_UPDATED]: 'Your email address has been successfully updated.',
  [PASSWORD_AND_SECURITY_EMPTY_PASSWORD]: 'Please confirm your password.',
  [PASSWORD_AND_SECURITY_PASSWORD]: 'You did not meet the password requirements. Please enter a valid password.',
  [PASSWORD_AND_SECURITY_PASSWORD_MATCH]: 'Your passwords do not match. Please try again.',
  [PASSWORD_AND_SECURITY_PASSWORD_UPDATED]: 'Your password has been reset. You can now use your new password to login.',
  [CONFIRM_TIRE_SIZE_PARAMETERS_EMPTY]: 'Please specify the width, ratio and diameter of your tires.'
}
